const elementId = "shopping-location-json";
const eventName = "shoppingLocationChanged";

const UpdateShoppingLocationService = {
  emitShoppingLocationChangedEvent: (address: unknown) => {
    const shoppingLocationJsonElement = document.getElementById(elementId);

    if (shoppingLocationJsonElement) {
      shoppingLocationJsonElement.innerText = JSON.stringify(address);
    }

    const event = document.createEvent("Event");
    event.initEvent(eventName, true, true);
    document.dispatchEvent(event);
    return event;
  },
  getShoppingLocation: () => {
    const shoppingLocationJsonElement = document.getElementById(elementId);

    if (shoppingLocationJsonElement && shoppingLocationJsonElement.innerText) {
      return JSON.parse(shoppingLocationJsonElement.innerText);
    }

    return null;
  },
  shoppingLocationChangedEventName: eventName,
  inject() {
    const shoppingLocationJsonElement = document.getElementById(elementId);

    if (!shoppingLocationJsonElement) {
      const shoppingLocationElement = document.createElement("div");
      shoppingLocationElement.style.display = "none";
      shoppingLocationElement.id = elementId;
      document.body.prepend(shoppingLocationElement);
    }
  },
};

export default UpdateShoppingLocationService;
